<template>
  <div class="up_down_navigation">
    <div class="py-1" v-if="up">
      <v-btn width="28" height="28" icon dark class="primary" @click="scrollTop">
        <v-icon small>fas fa-angle-up</v-icon>
      </v-btn>
    </div>
    <div class="py-1" v-if="down">
      <v-btn width="28" height="28" icon dark class="primary" @click="scrollDown">
        <v-icon small>fas fa-angle-down</v-icon>
      </v-btn>
    </div>
  </div>
</template>


<script>
import './style.scss'
export default {
  name: 'UpDownNavigation',
  props: {
    up: {
      type: Boolean,
      default: true
    },
    down: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    scrollTop() {
      window.scroll({
        top: 0,
        behavior: 'smooth'
      });
    },
    scrollDown() {
      window.scroll({
        top: document.body.scrollHeight,
        behavior: 'smooth'
      });
    },
  }
}
</script>